export const HEADER_HEIGHT = 44;
export const NAV_RAIL_WIDTH = 56;
export const NAV_RAIL_WIDTH_EXPANDED = 236;
export const NAV_SUB_WIDTH = 224;
export const LANDING_MAIN_GUTTER_PX = 24;
export const SIDER_WIDTH = NAV_RAIL_WIDTH + NAV_SUB_WIDTH;
export const SIDER_COLLAPSED_WIDTH = NAV_RAIL_WIDTH;
